import * as React from 'react'
import { observer } from 'mobx-react'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import { useActivation } from 'hooks/mobx-hooks'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import { ContentLayout, ContentMain } from 'components/ContentLayout'
import ContentError from 'components/ContentError'
import ListHeader from 'components/ListHeader'
import { AdminTransactionHistoryViewModel } from 'payouts/admin/transaction-history/AdminTransactionHistoryViewModel'
import PayoutsAdminHeader from 'payouts/admin/components/PayoutsAdminHeader'
import HistoricalTransactionsTable from './HistoricalTransactionsTable'

interface TransactionHistoryProps {
  vm: AdminTransactionHistoryViewModel
}

/**
 * The TransactionHistory
 */
export default observer(function TransactionHistory({
  vm,
}: TransactionHistoryProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  useActivation(vm)

  if (!vm.canAccessPayoutsAdministration) {
    return (
      <ContentError
        title="Denied"
        large
        error="You are not allowed to access this page."
      />
    )
  }

  return (
    <Sandwich stretch>
      <SandwichBun>
        <PayoutsAdminHeader scrollOffset={scrollOffset} />
      </SandwichBun>
      <SandwichContent stretch>
        <ContentLayout accountForLabel accountForTabBar fill ref={scrollRef}>
          <ContentMain fill constrainWidth>
            <Sandwich stretch>
              <SandwichBun>
                <ListHeader count={vm.transactionsCount || undefined}>
                  Paid out transactions
                </ListHeader>
              </SandwichBun>
              <SandwichContent stretch>
                <HistoricalTransactionsTable vm={vm} />
              </SandwichContent>
            </Sandwich>
          </ContentMain>
        </ContentLayout>
      </SandwichContent>
    </Sandwich>
  )
})
